<template>
	<div class="box login-header-container flex-justify-between flex-align-center pad-lr-default">
		<div class="login-header-logo">
			<!-- <img v-show="status.logo === 'nodata'" src="../../assets/image/login-header-logoV2.png" alt=""> -->
			<img v-show="status.logo === 'loading'" src="../../../../common/src/assets/loading.gif" alt="">
			<img v-show="status.logo === 'havedata'" :src="companyLogo" alt="">

		</div>
		<div class="box flex-align-center">
			<!-- <router-link to="/doc" class="header-home-text">首页</router-link> -->
			<div class="header-home-text" @click="skiphome">首页</div>
		</div>
	</div>
</template>

<script>
    import LoginHeader from './login-header';
    export default LoginHeader;
</script>

<style lang="scss" scoped>
.login-header-logo {
	height: 100%;
	display: flex;
	align-items: center;
	img {
		max-height: 50px;
		max-width: 180px;
	}
}
.login-header-container {
	width: 100%;
    height: 56px;
	border-bottom: 1px solid #DBE4EF;
	box-shadow: unset;
}
.header-home-text {
	color: #555;
	text-decoration: unset;
	cursor: pointer;
}

</style>
